import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import NoDataToDisplay from "highcharts/modules/no-data-to-display";
import { React, useEffect, useState } from "react";
import { formatDateFromBigInt, formatTimeRange1, formatTimeRange2 } from "../common/commonMethod";
import zIndex from "@mui/material/styles/zIndex";

NoDataToDisplay(Highcharts);

const UI_1_1_Chart = (props) => {
  const { chartData, interval, method } = props;
  console.log("UI_1_1_Chart data........ ", chartData);

  const createTimeIndexMap = (timeRanges) => {
    const map = new Map();
    timeRanges.forEach((time, index) => {
      if (!map.has(time)) {
        map.set(time, index);
      }
    });
    return map;
  };

  const realtimeProd = chartData.map(item => formatTimeRange1(item.prodDtm)).sort();
  const realtimeCons = chartData.map(item => formatTimeRange1(item.consDtm)).sort();
  const dayProd = chartData.map(item => formatDateFromBigInt(item.prodDate)).sort();
  const dayCons = chartData.map(item => formatDateFromBigInt(item.consDate)).sort();

  const realtimeProdMap = createTimeIndexMap(realtimeProd);
  const realtimeConsMap = createTimeIndexMap(realtimeCons);

  const UI_1_1_SeriesData_realtime = {
    amount: {
      name: '실제',
      type: 'line',
      color: '#d05353',
      zIndex: 2,
      data: []
    },
    expectedAmount: {
      name: '예측',
      type: 'column',
      color: '#0080ff',
      zIndex: 1,
      data: []
    }
  };

  const UI_1_1_SeriesData_day = {
    amount: {
      name: '실제',
      type: 'column',
      color: '#d05353',
      zIndex: 2,
      data: []
    },
    expectedAmount: {
      name: '예측',
      type: 'column',
      color: '#0080ff',
      zIndex: 1,
      data: []
    },
    accuracy: {
      name: '예측정확도',
      color: 'rgba(0,0,0,0)',
      lineWidth: 0,
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false  // 마우스 오버 시에도 마커를 표시하지 않음
          }
        }
      },
      showInLegend: false,
      data: []
    },
  };

  chartData.forEach(item => {
    let date = null;
    let index = null;

    if (interval === "realtime") {
      if (method === "prod") {
        date = formatTimeRange1(item.prodDtm);
        index = realtimeProdMap.get(date);
        if (index !== undefined) {
          UI_1_1_SeriesData_realtime.amount.data.push([index, item.prodAmt ? item.prodAmt : 0]);
          UI_1_1_SeriesData_realtime.expectedAmount.data.push([index, item.expProdAmt ? item.expProdAmt : 0]);
          if (date.includes('23:45 ~ 23:59')) {
            UI_1_1_SeriesData_realtime.amount.data.push([index + 1, null]); // 마지막 데이터 후에 null 추가
            UI_1_1_SeriesData_realtime.expectedAmount.data.push([index + 1, null]);
          }
        }
      } else {
        date = formatTimeRange1(item.consDtm);
        index = realtimeConsMap.get(date);
        if (index !== undefined) {
          UI_1_1_SeriesData_realtime.amount.data.push([index, item.consAmt ? item.consAmt : 0]);
          UI_1_1_SeriesData_realtime.expectedAmount.data.push([index, item.expConsAmt ? item.expConsAmt : 0]);
        }
      }
    } else {
      if (method === "prod") {
        date = formatDateFromBigInt(item.prodDate);
        index = dayProd.indexOf(date);
        UI_1_1_SeriesData_day.amount.data.push([index, item.prodAmt ? item.prodAmt : 0]);
        UI_1_1_SeriesData_day.expectedAmount.data.push([index, item.expProdAmt ? item.expProdAmt : 0]);
        UI_1_1_SeriesData_day.accuracy.data.push([index, item.accuracy ? item.accuracy : 0]);
      } else {
        date = formatDateFromBigInt(item.consDate);
        index = dayCons.indexOf(date);
        UI_1_1_SeriesData_day.amount.data.push([index, item.consAmt ? item.consAmt : 0]);
        UI_1_1_SeriesData_day.expectedAmount.data.push([index, item.expConsAmt ? item.expConsAmt : 0]);
        UI_1_1_SeriesData_day.accuracy.data.push([index, item.accuracy ? item.accuracy : 0]);
      }
    }
  });

  const options = {
    chart: {
      backgroundColor: "transparent"
    },
    credits: {
      enabled: false,
    },
    title: {
      text: null,
    },
    tooltip: {
      shared: true,
      useHTML: true
    },
    lang: {
      noData: '데이터가 존재하지 않습니다'
    },
    noData: {
      style: {
        fontSize: '14px',
        fontWeight: 500
      }
    },
    xAxis: {
      type: 'category',
      categories: interval === "realtime" ? (method === "prod" ? realtimeProd : realtimeCons) : (method === "prod" ? dayProd : dayCons),
      tickmarkPlacement: 'on',
      crosshair: true,
      gridLineWidth: 0
    },
    yAxis: {
      title: {
        text: null
      },
      gridLineWidth: 0,
      min: 0,
    },
    plotOptions: {
      series: {
          connectEnds: false
      }
    },
    legend: {
      itemStyle: {
          color: 'rgba(200, 200, 200)'
      }
    },
    series: interval === "realtime" ? Object.values(UI_1_1_SeriesData_realtime) : Object.values(UI_1_1_SeriesData_day)
  };

  return (
    <div>
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
      />
    </div>
  );
};

export default UI_1_1_Chart;